export enum PaymentStatuses {
  RequiresPaymentMethod = 'RequiresPaymentMethod',
  Processing = 'Processing',
  Succeeded = 'Succeeded',
  Failed = 'Failed'
}